import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FiscalQuota } from '@common/models';
import { FiscalQuotaOption } from '@common/utils/fiscal-quota.util';

/**
 * «Facturación fiscal» del modal de pago (ADM-740): cantidad de facturas adicionales al cupo
 * base del Plan Fiscal. Presentacional: las opciones, la cantidad y si se puede editar los
 * decide `fina-form-pay-plan` (`getExtraControlNumbersOptions`, `canEditExtraControlNumbers`).
 */
@Component({
    selector: 'fina-fiscal-quota-select',
    templateUrl: './fiscal-quota-select.component.html',
    styleUrls: ['./fiscal-quota-select.component.scss'],
})
export class FiscalQuotaSelectComponent {
    /** Opciones de `buildFiscalQuotaOptions` (0, tiers y la cantidad vigente «(actual)»). */
    @Input() options: FiscalQuotaOption[] = [];
    /** Cantidad pedida: la opción que se marca. */
    @Input() value = 0;
    /** Cupo base mensual del Plan Fiscal (`fiscalOffer.includedQuantity`). */
    @Input() includedQuantity: number | null = null;
    @Input() canEdit = false;
    /** Cupo vigente que se muestra en solo lectura (mitad de ciclo o factura no pendiente). */
    @Input() readOnlyQuota: FiscalQuota | null = null;
    @Output() valueChange = new EventEmitter<number>();

    trackOption(_index: number, option: FiscalQuotaOption): number {
        return option.quantity;
    }

    onSelect(raw: string): void {
        const quantity = Number(raw);
        if (!Number.isFinite(quantity)) {
            return;
        }
        this.valueChange.emit(quantity);
    }
}
